import {Component, EventEmitter, Output} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {PAGES_AND_PATHS} from '../../../../constants/pages-and-paths';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'tl-public-list-modal',
  standalone: true,
  imports: [
    TranslateModule,
    RouterLink
  ],
  templateUrl: './public-list-modal.component.html',
})
export class PublicListModalComponent {
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
}
